const ToggleButton = ({ isMonthly, onToggle, dataTestId }) => (
  <div className="flex gap-1 bg-gray-100 rounded-full p-1" data-testid={dataTestId}>
    <button
      data-testid={`${dataTestId}-monthly`}
      className={`toggle-btn ${isMonthly ? "active" : "inactive"}`}
      onClick={() => onToggle(true)}
    >
      Monthly
    </button>
    <button
      data-testid={`${dataTestId}-yearly`}
      className={`toggle-btn ${!isMonthly ? "active" : "inactive"}`}
      onClick={() => onToggle(false)}
    >
      Yearly
    </button>
  </div>
);

export default ToggleButton;
